import { InfiniteData, useQueryClient } from 'react-query'
import { RatingComparisonResponse } from '../types'
import { useTheme } from '@fable/theme'
import { usePreloadImageBulk } from '@fable/hooks'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const useChartData = () => {
  const theme = useStatsTheme((s) => s.theme)
  const { colors } = useTheme()
  const [year, statsUserId] = useStats((s) => [s.year, s.statsUserId])
  const client = useQueryClient()
  const queryKey = ['stats-community-rating', statsUserId, year]
  const data =
    client.getQueryData<InfiniteData<RatingComparisonResponse>>(queryKey)
  const results = data?.pages.flatMap((page) => page.data.results) || []

  const preloadedCovers = usePreloadImageBulk(
    results.map((item) => ({
      id: item.book.id,
      width: 200,
      url: item.book.cover_image_small,
    }))
  )

  const bookIds = new Set<string>()

  const finalResults = [...results]
    .filter((item) => item.book.rating > 0 || item.book.avg_rating > 0)
    .filter((item) => {
      if (bookIds.has(item.book.id)) return false
      bookIds.add(item.book.id)
      return true
    })

  const user = {
    id: 'you',
    color: theme.colors.primary,
    data:
      finalResults.map((item) => ({
        x: item.book.id,
        y: item.book.rating || null,
      })) || [],
  }

  const community = {
    id: 'community',
    color: colors.uiPearl,
    data:
      finalResults.map((item) => ({
        x: item.book.id,
        y: item.book.avg_rating || null,
      })) || [],
  }

  const covers = finalResults.map((item) => {
    const image = preloadedCovers[item.book.id]?.src || ''
    return `${image}&mode=cors`
  })

  return { covers, data: [user, community] }
}
